import {
  Anchor,
  Box,
  Button,
  Center,
  Divider,
  Group,
  HoverCard,
  SimpleGrid,
  ThemeIcon,
  UnstyledButton,
  rem,
  useMantineTheme,
  Text,
} from "@mantine/core";
import {useDisclosure} from "@mantine/hooks";
import {IconChevronDown} from "@tabler/icons-react";
import {link} from "fs";
import React from "react";

import classes from "./DesktopDropdown.module.scss";

type DesktopDropdownProps = {
  label: string;
  darkMode?: boolean;
  dropdown: {
    title: string;
    viewAllLink?: string;
    subLinks: Array<{
      link?: string | undefined;
      label: string;
      onClick?: Function | undefined;
      description: string;
      icon: any;
    }>;
    footer: {
      title: string;
      description: string;
      linkLabel: string;
      linkOnClick?: Function;
      link?: string;
    };
  };
};
export default function DesktopDropdown({label, dropdown, darkMode}: DesktopDropdownProps) {
  const theme = useMantineTheme();
  return (
    <HoverCard width={600} position="bottom" radius="md" shadow="md" withinPortal>
      <HoverCard.Target>
        <Button
          //ml={"auto"}
          key={label}
          variant="subtle"
          radius="xl"
          fw={400}
          color={darkMode ? "white" : "text"}
          className={classes.link}>
          <Center inline>
            <Box component="span" mr={5} fz={rem(15)}>
              {label}
            </Box>
            <IconChevronDown
              style={{width: rem(16), height: rem(16)}}
              color={darkMode ? theme.colors.white[6] : theme.colors.blue[6]}
            />
          </Center>
        </Button>
      </HoverCard.Target>

      <HoverCard.Dropdown style={{overflow: "hidden"}}>
        <Group justify="space-between" px="md">
          <Text fw={400}>{dropdown.title}</Text>
          {dropdown.viewAllLink && (
            <Anchor href={dropdown.viewAllLink} fz="xs">
              View all
            </Anchor>
          )}
        </Group>

        <Divider my="sm" />

        <SimpleGrid cols={2} spacing={1}>
          {dropdown.subLinks.map((item) => (
            <UnstyledButton
              className={classes.dropdownLinkSubLink}
              key={item.label}
              onClick={item.onClick ? (e) => item.onClick?.() : undefined}
              renderRoot={item.link ? (props) => <a href={item.link} {...props} /> : undefined}>
              <Group wrap="nowrap" align="flex-start">
                <ThemeIcon size={34} variant="default" radius="md">
                  <item.icon style={{width: rem(22), height: rem(22)}} color={theme.colors.blue[6]} />
                </ThemeIcon>
                <div>
                  <Text size="sm" fw={500}>
                    {item.label}
                  </Text>
                  <Text size="xs" c="dimmed">
                    {item.description}
                  </Text>
                </div>
              </Group>
            </UnstyledButton>
          ))}
        </SimpleGrid>

        <div className={classes.dropdownFooter}>
          <Group justify="space-between">
            <div>
              <Text fw={500} fz="sm">
                {dropdown.footer.title}
              </Text>
              <Text size="xs" c="dimmed">
                {dropdown.footer.description}
              </Text>
            </div>
            {(dropdown.footer.link || dropdown.footer.linkOnClick) && (
              <Button
                //ml={"auto"}
                variant="outline"
                radius="xl"
                fw="500"
                size="sm"
                fs={".06rem"}
                color={"text"}
                onClick={
                  dropdown.footer?.linkOnClick
                    ? (e) => {
                        dropdown!.footer.linkOnClick?.();
                      }
                    : undefined
                }
                renderRoot={dropdown.footer.link ? (props) => <a href={dropdown!.footer.link} {...props} /> : undefined}
                className={classes.button + " " + classes.dropdownButton}>
                {dropdown.footer.linkLabel}
              </Button>
            )}
          </Group>
        </div>
      </HoverCard.Dropdown>
    </HoverCard>
  );
}
